import React from 'react';
import Chart from "react-apexcharts";

export default function GraficoTipoComprobante(props) {
    const options = {
        chart: {
          width: 380,
          type: 'donut',
        },
        title: {
            text: 'Comprobantes - Total por Tipo'
          },
        series: props.series,
        labels: props.tiposcomprobante,
        colors: ['#008ffb', '#8cd369', '#feb019', '#E91E63'],
        responsive: [{
            breakpoint: 700,
            options: {
                chart: {
                    width: 500
                },
                legend: {
                    position: 'bottom'
                }
            }
        }]
    }
    return (
        <div id="chart">
            <Chart 
                options={options} 
                series={options.series} 
                type="donut" width={380} 
            />
        </div>
    );
}